/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2022-03-16:17:43
 */

 import Api from 'src/util/api';
 import { PageDo, Result, ResultPageDo, Integer } from 'src/types/base';
 export declare namespace HexFileDOI {
    export interface HexFile {
        id: number
        name: string
        parent_id: number
        type:number
        file_version:string
        children_list: HexFile[]
    }

    export interface RowDataI {
        id: number;
        name: string;
        parent_id: number;
    }

    export interface OperateParamsI {
        id?:Integer
        name: string
        parent_id: Integer
    }

    export interface OperateParamsIs {
        id?:Integer
        name: string
        parent_id: Integer
        file_url:string
        file_version:string
    }
 }

 export default class HexFileApi{
     /**
      * 查询目录树
      */
    static async searchCatalogueTree(): Promise<Result<HexFileDOI.HexFile>> {
        return Api.post('/monitor/get/catalogue_tree', {});
    }
    
    
    /**
     * 根据父目录查询子目录
     * @param parent_id 
     */
    static async parentIdByChild(parent_id: number): Promise<Result<HexFileDOI.RowDataI[]>>
    {
       return Api.post('/monitor/get/parent/by_id', {parent_id});
    }
   
    /**
     * 添加文件目录
     * @param data 
     */
    static async add(data: HexFileDOI.OperateParamsI): Promise<Result<any>> {
        return Api.post('/monitor/add/catalogue', data);
    }

    /**
     * 修改文件目录
     */
    static async update(data: HexFileDOI.OperateParamsI): Promise<Result<any>> {
        return Api.post('/monitor/edit/catalogue', data);
    }

     /**
     * 删除
     */
    static async delete(id: number ): Promise<Result<any>> {
        return Api.post('/monitor/delete/catalogue', {id});
    }
     
    /**
     * 新增文件
     * @param data 
     */
    static async addFile(data: HexFileDOI.OperateParamsI): Promise<Result<any>> {
        return Api.post('/monitor/file_catalogue/add/file', data);
    }
 }